module.exports = {"man":"Man","woman":"Woman","transgender":"Trans"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/genders.json
// module id = rmV5
// module chunks = 27